import { Pipe, PipeTransform } from '@angular/core';
import { SpaceUser } from '@interfaces/space';
import { User } from '@interfaces/user';
@Pipe({
  name: 'userInitials',
  standalone: false,
})
export class UserInitialsPipe implements PipeTransform {
  /**
   * Transforms user data to return initials.
   * Prioritizes first_name and last_name. If not available, uses the first two letters of the email.
   *
   * @param user The user object containing first_name, last_name, and/or email.
   * @returns The initials (e.g., "JD", "EM", "NA")
   */
  transform(user: User | null | SpaceUser): string {
    if (!user) {
      return 'NA';
    }

    const firstName = user.first_name?.trim();
    const lastName = user.last_name?.trim();
    const email = user.email?.trim();

    let initials = '';

    if (firstName && lastName) {
      initials = firstName.charAt(0) + lastName.charAt(0);
    } else if (firstName) {
      initials = firstName.charAt(0);
    } else if (lastName) {
      initials = lastName.charAt(0);
    }

    if (initials.length === 0 && email && email.length >= 2) {
      initials = email.substring(0, 2);
    }

    return initials.toUpperCase() || 'NA';
  }
}
